import { render } from "./Binghai.vue?vue&type=template&id=f2efbd76&scoped=true"
import script from "./Binghai.vue?vue&type=script&lang=js"
export * from "./Binghai.vue?vue&type=script&lang=js"

import "./Binghai.vue?vue&type=style&index=0&id=f2efbd76&lang=less&scoped=true"

import exportComponent from "E:\\上蔡\\大数据\\窄版\\shancgai - 窄版 - 圆导航\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f2efbd76"]])

export default __exports__